var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 16,
    viewBox: "0 0 49 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3925 15.5151H17.5389L19.9477 0.836566H23.8013L21.3925 15.5151ZM14.2961 0.834455L10.6233 10.9311L10.1893 8.75726L8.89338 2.15774C8.89338 2.15774 8.73592 0.836566 7.06554 0.836566H0.992583L0.922363 1.0856C0.922363 1.0856 2.78 1.46971 4.95256 2.76345L8.29971 15.5172H12.315L18.4454 0.838675H14.2982L14.2961 0.834455ZM44.6034 15.5151H48.142L45.0566 0.836566H41.9584C40.5285 0.836566 40.1795 1.9298 40.1795 1.9298L34.4321 15.5151H38.4496L39.2518 13.3349H44.1501L44.6013 15.5151H44.6034ZM40.3647 10.3211L42.3883 4.82751L43.5267 10.3211H40.3625H40.3647ZM34.7364 4.36531L35.2854 1.21223C35.2854 1.21223 33.5895 0.572754 31.8191 0.572754C29.9062 0.572754 25.3653 1.40218 25.3653 5.43323C25.3653 9.22579 30.6956 9.27222 30.6956 11.2645C30.6956 13.2568 25.9143 12.9002 24.3375 11.6444L23.7651 14.941C23.7651 14.941 25.4866 15.7704 28.1145 15.7704C30.7424 15.7704 34.7109 14.4197 34.7109 10.7453C34.7109 7.07097 29.3337 6.57289 29.3337 4.91404C29.3337 3.25519 33.0873 3.46835 34.7364 4.36954V4.36531Z",
    fill: "#2566AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1893 8.75728L8.89338 2.15564C8.89338 2.15564 8.73592 0.834473 7.06554 0.834473H0.992583L0.922363 1.08351C0.922363 1.08351 3.84181 1.68289 6.63996 3.93057C9.31683 6.07906 10.1893 8.75728 10.1893 8.75728Z",
    fill: "#E6A540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.c8ddadf683ecc393911fc6a0223b8d7e.svg";
export { ForwardRef as ReactComponent };